export default "data:image/gif;base64,R0lGODlhEgAMAPEAAP//AP8AAAAA/wAAACH5BAAAAAAALAAAAAASAAwAAAIjlA+pwX2oUnNPRDlDtTfregHeFo5gl5HopEbmU6anK8NrUwAAOw=="